module.exports = __webpack_public_path__ + "static/favicon-06f9f6f85f73c310574d0f8a9566af2b.ico";